import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetAccountDetailsResponse,
  getAccountDetails as universalGetAccountDetails,
} from './email-marketing-v1-account-details-account-details.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/email-marketing' };

export function getAccountDetails(
  httpClient: HttpClient
): GetAccountDetailsSignature {
  return () =>
    universalGetAccountDetails(
      // @ts-ignore
      { httpClient }
    );
}

interface GetAccountDetailsSignature {
  /**
   * Retrieves email marketing account details.
   */
  (): Promise<
    NonNullablePaths<
      GetAccountDetailsResponse,
      | `accountDetails.status`
      | `accountDetails.package._id`
      | `accountDetails.package.group`
      | `accountDetails.package.monthlyQuotaAllocation.campaigns`
      | `accountDetails.package.monthlyQuotaAllocation.emails`
      | `accountDetails.maxCampaignAudienceSize`,
      5
    >
  >;
}

export {
  AccountDetails,
  Action,
  AutomationOptions,
  BillingCycle,
  ComplianceDetails,
  ComplianceDetailsProductOptionsOneOf,
  Content,
  EmailMarketingOptions,
  Enum,
  Features,
  GetAccountDetailsRequest,
  GetAccountDetailsResponse,
  GetComplianceDetailsRequest,
  GetComplianceDetailsResponse,
  Package,
  Product,
  Quota,
  QuotaPeriod,
  Rank,
  RespondRequest,
  RespondResponse,
  RestrictionReason,
  RestrictionReasonTypeOneOf,
  SenderReputation,
  Statistics,
  SupportTicketData,
} from './email-marketing-v1-account-details-account-details.universal.js';
